import React from 'react';
import { observer } from 'mobx-react';
import { Spin } from 'antd';

import Modal from './Modal';
import Store from './Store';
import MainTable from './MainTable';
import Toolbar from './Toolbar';
import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

class TalkingPointCategory extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/talking-point-category', true);
      return;
    }
    Store.fetchAll(true);
  }
  render() {
    const { data, loading, open } = Store;
    return (
      <div className={`Table-${loading && !data ? 'loading' : 'container'}`}>
        {loading && !data ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <Toolbar />
            <MainTable />
            {open && <Modal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}
export default observer(TalkingPointCategory);
